import { useQuery } from '@apollo/client';

import { CURRENT_USER } from '../graphql/query/currentUserQuery.graphql';

export const useCurrentUserQuery = (noToast = false) => {
  return useQuery(CURRENT_USER, {
    context: {
      noToast,
    },
  });
};
